// ABOUTME: Token generation and validation for magic links via the Worker API.
// ABOUTME: Replaces Supabase token storage with API calls.

import { api } from "@/lib/supabase/client";
import { debug } from "@/lib/utils";
import { config } from "@/lib/config";

export interface QuoteTokenPayload {
  quoteId: string;
  tradeId: string;
  exp: number;
  jti: string;
}

export interface TokenValidationResult {
  isValid: boolean;
  token: QuoteTokenPayload | null;
  reason?: 'expired' | 'not_found' | 'invalid_format' | 'unknown';
  expiresIn?: number;
}

export async function generateQuoteToken(
  quoteIdOrParams: string | { quoteId: string; tradeId: string; expiresIn?: number },
  tradeId?: string,
  expiresIn?: number
): Promise<string> {
  let qId: string, tId: string, expIn: number | undefined;

  if (typeof quoteIdOrParams === 'string') {
    qId = quoteIdOrParams;
    tId = tradeId!;
    expIn = expiresIn;
  } else {
    qId = quoteIdOrParams.quoteId;
    tId = quoteIdOrParams.tradeId;
    expIn = quoteIdOrParams.expiresIn;
  }

  const { token } = await api.post<{ token: string }>('/tokens/generate', {
    quote_id: qId, trade_id: tId, expires_in: expIn || config.tokenExpirationTime,
  });

  return token;
}

export async function validateQuoteToken(token: string): Promise<TokenValidationResult> {
  try {
    const result = await api.post<TokenValidationResult>('/tokens/validate', { token });
    return result;
  } catch {
    return { isValid: false, token: null, reason: 'unknown' };
  }
}

export async function revokeQuoteToken(jti: string): Promise<boolean> {
  try {
    await api.del(`/tokens/${jti}`);
    return true;
  } catch {
    debug.error('Error revoking quote token');
    return false;
  }
}

export function constructMagicLink(token: string): string {
  return `${config.magicLinkBaseUrl}/trades/quote/${token}`;
}

export async function cleanupExpiredTokens(): Promise<number> {
  return 0;
}
